/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue"
import * as sentry from "@sentry/vue"

export function useSentry () {
  const dsn = process.env.VUE_APP_SENTRY_DSN || ""

  if (dsn) {
    sentry.init({
      Vue: Vue,
      dsn: dsn,
      logErrors: true,
      environment: process.env.VUE_APP_ENVIRONMENT
    })
  }
}
